module.exports={render:function (){with(this) {
  return _h('div', [_h('div', {
    staticClass: "container-fluid bg-primary frontBanner"
  }, [_h('div', {
    staticClass: "container"
  }, [_h('transition', {
    attrs: {
      "appear": "",
      "name": "fade",
      "mode": "out-in"
    }
  }, [(this.authData) ? _h('div', {
    key: "authorised",
    staticClass: "row"
  }) : _h('div', {
    key: "unauthorised",
    staticClass: "row"
  }, [_h('div', {
    staticClass: "col-lg-2"
  }), " ", _h('div', {
    staticClass: "col-lg-8"
  }, [_h('h2', ["Enter your details to login."]), " ", _h('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        userLogin($event)
      }
    }
  }, [_h('div', {
    staticClass: "form-group"
  }, [_h('input', {
    directives: [{
      name: "model",
      value: (txtEmail),
      expression: "txtEmail"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": _s(txtEmail)
    },
    on: {
      "keydown": function($event) {
        if ($event.keyCode !== 13) return;
        $event.preventDefault();
        focusNextField($event)
      },
      "input": function($event) {
        if ($event.target.composing) return;
        txtEmail = $event.target.value
      }
    }
  })]), " ", _h('div', {
    staticClass: "form-group"
  }, [_h('input', {
    directives: [{
      name: "model",
      value: (txtPassword),
      expression: "txtPassword"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": _s(txtPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) return;
        txtPassword = $event.target.value
      }
    }
  })]), " ", _h('button', {
    staticClass: "btn btn-default btn-block btn-info btn-lg",
    attrs: {
      "type": "submit"
    }
  }, ["Login"])]), " ", _h('h3', {
    staticClass: "text-center"
  }, [_h('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        userResetPassword($event)
      }
    }
  }, ["Forgotten your password?"])]), " ", (messageError) ? _h('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_s(messageError)]) : _e(), " ", (messageSuccess) ? _h('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_s(messageSuccess)]) : _e()]), " ", _h('div', {
    staticClass: "col-lg-2"
  })]), " "])])])])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginform.vue
 ** module id = 87
 ** module chunks = 2
 **/